import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, urlsData } from "@/data";
import { getMemberQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useGetMember = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { data, error, loading } = useQuery(getMemberQuery, {
        skip: !isAuthenticated || !id,
        variables: {
            where: { id },
        },
    });

    useEffect(
        () => {
            if (!loading && data && !data.driveMember) navigate(urlsData.routes.notFound);
        },
        [data, loading], // eslint-disable-line
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data,
        loading,
    };
};

export default useGetMember;
